var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { RowLayout } from "../row-layout";
import { FormLayoutContext } from "./form-layout-context";
export var FormLayout = React.forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.layout, layout = _b === void 0 ? "two-column" : _b, _c = _a.fullWidth, fullWidth = _c === void 0 ? true : _c, boxProps = __rest(_a, ["children", "layout", "fullWidth"]);
    var ctx = React.useMemo(function () { return ({ layout: layout, fullWidth: fullWidth }); }, [layout, fullWidth]);
    var isFullWidth = fullWidth || layout === "two-column";
    return (React.createElement(FormLayoutContext.Provider, { value: ctx },
        React.createElement(RowLayout, __assign({ width: { md: isFullWidth ? "100%" : "60%" }, gutter: 5 }, { ref: ref }, boxProps), children)));
});
